import { render, staticRenderFns } from "./PdpRaddar.vue?vue&type=template&id=5343c99d&scoped=true&"
import script from "./PdpRaddar.vue?vue&type=script&lang=js&"
export * from "./PdpRaddar.vue?vue&type=script&lang=js&"
import style0 from "./PdpRaddar.vue?vue&type=style&index=0&id=5343c99d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5343c99d",
  null
  
)

export default component.exports